import { InputForm } from "components/ui/inputForm";
import InputAdornment from "@mui/material/InputAdornment";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import { RiLockPasswordFill } from "react-icons/ri";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { IconButton } from "@mui/material";

export const PasswordIput = ({ name = "password", label = "Contraseña" }) => {
  const { formState } = useFormContext();
  const [showPassword, setShowPassword] = useState(false);

  // console.log();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <InputForm
      autoComplete="off"
      name={name}
      label={label}
      type={showPassword ? "text" : "password"}
      className="w-full"
      size="small"
      error={formState.errors[name] ? true : false}
      helperText={
        formState?.errors[name] ? formState.errors[name]?.message : ""
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <RiLockPasswordFill />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      rules={{
        required: {
          value: true,
          message: "El campo " + label + " es requerido",
        },
      }}
    />
  );
};
